<template>
  <div class="flex items-center">
    <label for="perPage" class="mr-1">
      {{ $t('components.tools.lexis_bridger.rows') }}
    </label>
    <select
      name="perPage"
      class="w-20 h-full outline-none font-bold bg-white border border-solid border-gray-200 pl-2 pr-4 py-1 rounded"
      v-model="perPageModel"
    >
      <option
        v-for="row in perPageOptions"
        :value="row"
        :key="'' + row"
      >
        {{ row }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'per-page',
  props: {
    value: {
      type: Number,
      default: 10,
    },
    perPageOptions: {
      type: Array,
      default: () => [10, 20, 30]
    }
  },
  computed: {
    perPageModel: {
      get() {
        return this.value;
      },
      set(value) {
        this.perPage = value;
        this.$emit('input', value);
      }
    }
  },
};
</script>